import Quill from 'quill';

const BlockEmbed = Quill.import('blots/block/embed') as any;

/**
 * A horizontal rule. Quill ships no `<hr>` blot of its own, so without this a
 * pasted separator — the line every WolfPack Friday Report puts between its
 * sections — was silently dropped on the way into the editor.
 *
 * Registering it is enough for the paste to work: Quill's `matchBlot` looks the
 * pasted node up in the registry, finds this blot for `HR` and turns it into a
 * `{ divider: true }` embed. It still has to be listed in the editor's `formats`
 * (a filtered registry) and in `CommunitySanitizer::ALLOWED_TAGS`, or one of the
 * two ends throws it away again.
 *
 * Importing this module registers the blot; `overwrite: true` keeps a second
 * import (a hot reload) from logging a warning.
 */
export class DividerBlot extends BlockEmbed {
  static blotName = 'divider';
  static tagName = 'hr';
}

Quill.register(DividerBlot, true);
